const baseURL = '/images';

async function process({ channel, type, image }) {
    const res = await axios.post(`${baseURL}/process`, {
        channel,
        type,
        image,
    });
    const data = res.data;
    if (data) {
        return data.processedImage;
    }
    return null;
}

async function deleteImage(filePath) {
    const res = await axios.delete(`${baseURL}${filePath}`);
    return res.data;
}

function uploadMyFile({ type, formData, params }) {
    return axios.post(`/uploads/${type}`, formData, {
        header: { 'Content-Type': 'multipart/form-data' },
        params,
    });
}

function deleteBrandingLogo({ type }) {
    return axios.delete(`/uploads/${type}`);
}

function uploadExternalFile({ type, formData, params }) {
    return axios.post(`/uploads/external/media`, formData, {
        header: { 'Content-Type': 'multipart/form-data' },
        params,
    });
}

function generateMedia({ data, campaignId }) {
    let config = {
        params: {
            campaignId,
        },
    };

    return axios.post('/category/addMedia', data, config);
}

function getCategoryList() {
    return axios.get('/category');
}

function getImageList(categoryId, campaignId) {
    const path =
        categoryId === 'thumbnails' ? categoryId : `media/${categoryId}`;
    return axios.get(`/category/${path}`, {
        params: {
            campaignId,
        },
    });
}

function deleteMyFiles(fileId, campaignId) {
    return axios.delete(`/category/deleteMyfile`, {
        data: { id: Number(fileId) },
        params: {
            campaignId,
        },
    });
}

export default {
    process,
    deleteImage,
    getCategoryList,
    getImageList,
    deleteMyFiles,
    uploadMyFile,
    uploadExternalFile,
    generateMedia,
    deleteBrandingLogo,
};
